/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { DtoRefreshSession } from '../../models/dto-refresh-session';
import { SessionResponse } from '../../models/session-response';

export interface IdentityControllerRefreshSession$Params {
      body: DtoRefreshSession
}

export function identityControllerRefreshSession(http: HttpClient, rootUrl: string, params: IdentityControllerRefreshSession$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: SessionResponse;
}>> {
  const rb = new RequestBuilder(rootUrl, identityControllerRefreshSession.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: SessionResponse;
      }>;
    })
  );
}

identityControllerRefreshSession.PATH = '/identity/session/refresh';
